// Marks a prompt whose result came from a user edit rather than the original run.
import { PencilLine } from 'lucide-react'

export function EditedBadge() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded border border-border bg-secondary/40 px-1.5 py-0.5 text-[10px] uppercase text-muted-foreground">
      <PencilLine className="size-2.5" />
      <span>Edited</span>
    </span>
  )
}
